import LinkBoxNavBar from "../containers/LinkBoxNavBar";
import { Request } from "../hooks/Request";
import { validateArray } from "../utils/validate";
import { H3 } from "../components/Text";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import config from "../config.json";
import { useSocketPending } from "../contexts/SocketPendingContext";
import { requestAuth } from "../components/services/RequestService";
import { LoadingSkeletonMenus } from "../components/Loaders";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RequestNoAuth } from "../hooks/RequestNoAuth";

const Navbar = (props) => {
  const { setNavsMenu, navsmenu, path } = props;
  const { rolId, menuName, document } = useParams();
  const { connectionPending, setConnectionId } = useSocketPending();
  const [socketReload, setSocketReload] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data, loading, call } = Request({
    urlApi: rolId ? `/rol/${rolId}/menu` : null,
  });

  const { data: dataGeneral } = RequestNoAuth({
    urlApi: "/institutionParams/generalData",
  });

  useEffect(() => {
    const connect = connectionPending.connect;
    if (connect) {
      connect.start().then(() => {
        connect.on("ListTypeProcedure", () => {
          // console.log("ListTypeProcedure nav");
          setSocketReload((a) => !a);
        });
        requestAuth(
          "post",
          `/auth/SocketConnection/${connect.connection.connectionId}`
        ).then(() => {
          setConnectionId(connect.connection.connectionId);
        });
      });
      // .catch((e) => console.log("Connection failed: ", e));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      data !== undefined &&
      data?.menuList &&
      data?.menuList?.length > 0 &&
      document === undefined &&
      !pathname.includes("/generate/dav")
    ) {
      navigate(`/rol/${rolId}/menu/${data?.menuList[0].name}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading]);
  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rolId]);

  return (
    <div
      className={`border-r border-[#618BCC21] bg-[#e1e8f5] shadow-lg transition-all duration-100 ease-linear ${navsmenu
        ? "w-[65px] min-w-[65px] portrait:w-[270px] portrait:min-w-[270px] portrait:hidden"
        : "w-[270px] min-w-[270px] portrait:absolute portrait:z-10"
        // } h-full bg-[#618BCC] overflow-y-auto pr-2`}
        } h-full overflow-y-auto`}
    >
      <div className="flex flex-justify-center self-center items-center h-[100px]">
        {/* {config.logoUrl && (
          <img
            src={config.logoUrl}
            alt="Logotipo"
            className="w-[70%] mx-auto my-auto rounded-md min-w-[45px]"
          />
        )} */}
        {
          dataGeneral?.find(d => d.code === 'icono')?.value && navsmenu ? (
            <img
              src={dataGeneral?.find(d => d.code === 'icono')?.value}
              alt="Logotipo"
              className="w-[100%] mx-auto my-auto min-w-[40px] max-w-[40px] p-1 items-center rounded-lg"
            />
          )
            :
            <img
              src={dataGeneral?.find(d => d.code === 'logo')?.value}
              alt="Logotipo"
              className="mx-auto my-auto min-w-[55px] max-w-[150px] w-auto max-h-[70px] p-1 items-center rounded-lg"
            />
        }
      </div>
      {/* <button
        className={`text-2xl ${navsmenu
          ? "text-center py-4 px-0 portrait:text-right portrait:p-4"
          : "text-left p-4"
          } w-full`}
        onClick={() => setNavsMenu(!navsmenu)}
      >
        <div className={navsmenu ? "" : "rotate-180"}>
          <i className="fas fa-angle-double-right"></i>
        </div>
      </button> */}
      {
        !loading ?
          <LoadingSkeletonMenus />
          :
          <nav
            className={`flex flex-col justify-center overflow-auto gap-1 p-1 ${navsmenu ? "" : ""
              }`}
          >
            {data?.menuList && data?.menuList?.length > 0
              ? data?.menuList.map((url) => {
                return (
                  <LinkBoxNavBar
                    key={url.id}
                    icon={
                      url.icon !== "" && url.icon !== null
                        ? url.icon
                        : "fa-regular fa-file-lines"
                    }
                    to={`/rol/${rolId}/menu/${url.name}`}
                    active={menuName === url.name || path === url.name}
                    setNavsMenu={setNavsMenu}
                    navsmenu={navsmenu}
                    label={url.label}
                  >
                    {navsmenu ? null : url.label}
                  </LinkBoxNavBar>
                );
              })
              : null}
            <ListStep
              {...props}
              navigate={navigate}
              redirect={data?.menuList && data?.menuList?.length > 0}
              socketReload={socketReload}
            />
          </nav>
      }
    </div>
  );
  // }
};

const ListStep = (props) => {
  const { setNavsMenu, navsmenu, redirect, navigate, path, socketReload } =
    props;
  const {
    rolId,
    // step: numberStep,
    procedureId,
    document,
  } = useParams();
  const location = useLocation();

  const { data, loading, call } = Request({
    // urlApi: `/processStep/ForRol/${rolId}`,
    urlApi: `/proceduretype/stepsperrol/${rolId}`,
  });

  useEffect(() => {
    if (data !== undefined && data.length > 0 && !redirect) {
      if (procedureId && document) {
        // navigate(
        //   `/rol/${rolId}/procedure-type/${typeId}/step/${numberStep}/procedure/${procedureId}/generate/${document}`,
        // )
      } else {
        navigate(
          `/rol/${rolId}/procedure-type/${data[0].id}/step/${data[0].processSteps[0].step}`
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, loading]);

  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [socketReload]);

  if (!loading) {
    return null;
  }

  return (
    <div className="">
      {data && data.length > 0 ? (
        <>
          {data.map((procedureType, index) => (
            <NavTypeProcedure
              key={procedureType.id}
              procedureType={procedureType}
              setNavsMenu={setNavsMenu}
              navsmenu={navsmenu}
              isView={index === 0}
            />
          ))}
          {
            (!location.pathname.includes("/menu/ClientList") && !location.pathname.includes("/menu/client-list")) &&
            <LinkBoxNavBar
              icon="fas fa-history"
              to={`/rol/${rolId}/history-procedure`}
              active={path === "history-procedure"}
              setNavsMenu={setNavsMenu}
              navsmenu={navsmenu}
            >
              {navsmenu ? null : "Mi historial"}
            </LinkBoxNavBar>
          }
        </>
      ) : null}
    </div>
  );
};

const NavTypeProcedure = ({ setNavsMenu, navsmenu, procedureType }) => {
  const [status, setStatus] = useState(true);
  const { rolId, typeId, step: numberStep } = useParams();

  if (!validateArray(procedureType.processSteps)) {
    return null;
  }

  return (
    <>
      <div
        onClick={() => setStatus(!status)}
        className="flex justify-between items-center py-[10px] pl-2 pr-2.5 gap-1 mb-1 border bg-[#618BCC] shadow-md border-[#618BCC10] rounded-lg cursor-pointer select-none text-white text-shadow"
      >
        <FontAwesomeIcon
          icon={"fa-regular fa-file-lines"}
          className={`text-lg w-6`}
        />
        <span className={'text-sm grow flex  justify-start font-medium'}>{navsmenu ? "" : procedureType.name}</span>
        {status ? (
          <FontAwesomeIcon
            icon={"fas fa-angle-down"}
            className={`text-sm`}
          />
        ) : (
          <FontAwesomeIcon
            icon={"fas fa-angle-right"}
            className={`text-sm`}
          />
        )}
      </div>
      {!validateArray(procedureType.processSteps) || status === false
        ? null
        : <div className={`flex flex-col gap-1 border-[#618BCC50] ${navsmenu ? "" : ""}`}>
          {
            procedureType.processSteps
              .sort((a, b) => a.step - b.step)
              .map((step, i) => (
                <LinkBoxNavBar
                  key={step.id}
                  icon="fas fa-route"
                  to={`/rol/${rolId}/procedure-type/${procedureType.id}/step/${step.step}`}
                  active={procedureType.id == typeId && step.step == numberStep}
                  setNavsMenu={setNavsMenu}
                  navsmenu={navsmenu}
                  pending={step.pendings}
                  step={step.step}
                  label={step.name}
                >
                  {navsmenu ? null : `${step.name}`}
                </LinkBoxNavBar>
              ))
          }
        </div>
      }
    </>
  );
};

export default Navbar;
